// extracted by mini-css-extract-plugin
module.exports = {"root":"RateTable_root__AKpw_","controlTabBar":"RateTable_controlTabBar__Mh7_w"};